import { JA_JP } from '@/components/organisms/RA2NDatePicker';
import { parseFormat } from '@/components/organisms/RA2NDatePicker/datepickerLogic';

export const DATEPICKER_FORMAT = parseFormat(JA_JP.format);
export const CONSULTATION_TYPE = '保険診療';
export const DISTANCE_WARNING_MSG = '距離が測定できません';
export const DEFAULT_VISIT_MINUTES = 20;
export const DEFAULT_VISIT_HOUR = 9;

export const HOUR_OPTIONS: { value: string; label: string }[] = [
  { value: '', label: '---' },
  ...Array.from({ length: 24 }, (_, i) => {
    const value = String(i).padStart(2, '0');
    return { value, label: value };
  }),
];

export const MINUTE_OPTIONS: { value: string; label: string }[] = [
  { value: '', label: '---' },
  ...Array.from({ length: 60 }, (_, i) => {
    const value = String(i).padStart(2, '0');
    return { value, label: value };
  }),
];
